import { FaqItem } from './FaqItem';
import { faq } from '../data/faq';
import { useI18n } from '../i18n/useI18n';

export function FaqSection() {
  const { t } = useI18n();

  return (
    <section className="section" id="faq">
      <div className="section-heading">
        <p className="eyebrow">{t('faq.eyebrow')}</p>
        <h2>{t('faq.title')}</h2>
      </div>
      <div className="faq-list">
        {faq.map((item) => (
          <FaqItem item={item} key={item.id} />
        ))}
      </div>
    </section>
  );
}
